import { installBrowserDiagnostics } from '@patsnap/synapse_common_utils'
import type { DiagnosticEventSink } from '@patsnap/synapse_common_utils'

let disposeBrowserDiagnostics: (() => void) | undefined
let diagnosticEventSink: DiagnosticEventSink | undefined

export function configureBrowserDiagnosticSink(sink?: DiagnosticEventSink): void {
  diagnosticEventSink = sink
  if (!sink) uninstallBrowserDiagnosticAdapter()
}

export function installBrowserDiagnosticAdapter(): void {
  if (disposeBrowserDiagnostics || !diagnosticEventSink || typeof window === 'undefined' || typeof document === 'undefined') return

  try {
    disposeBrowserDiagnostics = installBrowserDiagnostics({
      onEvent: (event) => diagnosticEventSink?.(event),
      getRoute() {
        return window.location.pathname
      },
      consoleLevels: ['error'],
    })
  } catch {
    // Diagnostics must not prevent application startup.
  }
}

export function uninstallBrowserDiagnosticAdapter(): void {
  disposeBrowserDiagnostics?.()
  disposeBrowserDiagnostics = undefined
}
